import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { AuthGuard } from 'app/auth/auth.guard';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { DashboardModule } from 'app/main/dashboard/dashboard.module';
import { routes } from 'app/main/main.routes';
import { MaterialModule } from 'app/main/material.module';
import 'moment/locale/fr';
import { MomentModule } from 'ngx-moment';
import { PCGModule } from 'app/main/pcg/pcg.module';
import { CompanyModule } from 'app/main/company/company.module';
import { AccountingModule } from 'app/main/accounting/accounting.module';
import { CubeModule } from 'app/main/cube/cube.module';
import { BalanceModule } from 'app/main/balance/balance.module';
import { JournalModule } from 'app/main/journal/journal.module';
import { AnalyticsModule } from 'app/main/analytics/analytics.module';
import { PlanModule } from 'app/main/plan/plan.module';
import { CustomerModule } from 'app/main/customer/customer.module';
import { ProviderModule } from 'app/main/provider/provider.module';
import { RuleModule } from 'app/main/rule/rule.module';
import { ChartsModule } from 'app/main/charts/charts.module';
import { PayrollModule } from 'app/main/payroll/payroll.module';

import { FileUploadModule } from 'app/main/file-upload/file-upload.module';
import { SnackbarModule } from 'app/main/shared/snackbar/snackbar.module';
import { CheckboxCellComponent } from 'app/main/shared/checkbox-cell/checkbox-cell.component';
import {
    KeyValueCellRendererComponent
} from 'app/main/shared/key-value-cell-renderer/key-value-cell-renderer.component';
import { PlModule } from 'app/main/p&l/pl.module';

@NgModule({
    declarations: [
        CheckboxCellComponent,
        KeyValueCellRendererComponent
    ],
    imports     : [
        RouterModule.forRoot(routes),
        FuseSharedModule,
        MaterialModule,
        PageTitleModule,
        MomentModule,
        PCGModule,
        CompanyModule,
        AccountingModule,
        CubeModule,
        BalanceModule,
        JournalModule,
        AnalyticsModule,
        PlanModule,
        RuleModule,
        CustomerModule,
        ProviderModule,
        FileUploadModule,
        DashboardModule,
        SnackbarModule,
        ChartsModule,
        // ADDING PAYROLL MODULE
        PayrollModule,
        PlModule
    ],
    exports     : [
        CheckboxCellComponent,
        KeyValueCellRendererComponent,
        RouterModule
    ],
    providers: [
        AuthGuard,
    ]
})

export class MainModule
{
}
